const apiRoutes = {
    auth: 'auth',
    register: 'users/register',
    verifyEmail: 'users/verify-email',
    eventParticipants: 'events/:eventId/participants',
    createParticipant: 'events/:eventId/participants',
    checkParticipant: 'events/:eventId/participants/check-user',
    mapParticipant: 'events/:eventId/participants/map-user',
    mapParticipantToEvent:
        'events/:eventId/participants/map-participant-to-event',
    updateParticipant: 'events/:eventId/participants/:participantId',
    getParticipantById: 'events/:eventId/participants/:participantId',
    participantPasswordResetLink:
        'events/:eventId/participants/:userId/reset-password-link',
    profilePhoto: 'events/:eventId/participants/:participantId/photo',
    bulkUpdateParticipants: 'events/:eventId/participants',
    archiveParticipants: 'events/:eventId/participants/archive',
    getParticipantFilters: 'events/:eventId/participants/filters',
    getParticipantUpdateOptionsByEvent:
        'events/:eventId/participants/update-options',
    getParticipantEvents: 'users/:userId/events',
    getEventSessions: 'events/:eventId/sessions',
    getSessionById: 'events/:eventId/sessions/v2/:sessionId',
    getSessionViewById: 'events/:eventId/sessions/v2/:sessionId/view',
    updateSessionById: 'events/:eventId/sessions/v2/:sessionId',
    bulkUpdateSessions: 'events/:eventId/sessions/v2',
    deleteSession: 'events/:eventId/sessions/v2',
    enrollSession: 'events/:eventId/sessions/v2/:sessionId/enroll',
    oneTimeModerator: 'events/:eventId/sessions/:sessionId/invite-moderator',
    getTargetAudienceUpdateOptionsByEvent:
        'events/:eventId/target-audiences/update-options',
    resetPasswordRequest: 'auth/reset-password/request',
    resetPasswordComplete: '/auth/reset-password/complete',
    getSessionUpdateOptionsByEvent: 'events/:eventId/sessions/update-options',
    getEnrollableUsersByEvent:
        'events/:eventId/sessions/:sessionId/enrollable-users',
    checkTargetAudienceByEvent: 'events/:eventId/target-audiences/check',
    checkEnrolledAudienceByEvent: 'events/:eventId/sessions/:sessionId/check',
    eventSessions: 'events/:eventId/sessions',
    eventSessionsV2: 'events/:eventId/sessions/v2',
    eventAccessReport: 'events/:eventId/participants/extra-reports',
    attendeesReport: 'events/attendees-report',
    attendeesFeedbackReport: 'event-hubs/feedbacks',
    getSessionFilters: 'events/:eventId/sessions/filters',
    participantSessions: 'events/:eventId/sessions/v2/view',
    viewDates: 'events/:eventId/sessions/v2/view-dates',
    viewDate: 'events/:eventId/sessions/v2/view-date',
    scheduledMeetings:
        'events/:eventId/meetings/:meetingId/intervals/:intervalId/participants',
    upcomingSessions: 'events/:eventId/sessions/v2/upcoming-sessions',
    getViewSessionFilters: 'events/:eventId/sessions/v2/view-filters',
    sessionAttendees: 'events/:eventId/sessions/v2/:sessionId/attendees',
    createSession: 'events/:eventId/sessions/v2',
    moderationSessions: 'sessions',
    getModerationDetailsById: 'sessions/:sessionId/instances',
    getModeratorQA:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers',
    getModeratorQAByModerationMagicLink: 'moderators/answers',
    updateInstance: 'engagement-tools/:engagementToolId/instances/:instanceId',
    updateModerationStatus:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/status',
    getInstanceDetailsById:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId',
    getInstanceDetailsByModerationMagicLink: 'moderators',
    getQuizStatusById:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/quiz/status',
    getInstanceDetailsForViewById:
        'engagement-tools/:engagementToolId/instances/view/:engagementToolInstanceId',
    updateModerationQAColumnValue:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/:answerId/moderate',
    updateModerationQAColumnValueByModerationMagicLink:
        'moderators/answers/:answerId/moderate',
    updateModerationQAReplyColumnValue:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/reply/:answerId',
    updateModerationQAReplyColumnValueByModerationMagicLink:
        '/moderators/reply/:answerId',
    getSurveyOrPollResult:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/results',
    getMagicLinkTokenForModeration:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/magic-link-token',
    getQaAnswerEditingPresence:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/editing-presence',
    getQaAnswerEditingPresenceByModerationMagicLink:
        'moderators/answers/editing-presence',
    startQaAnswerEditingPresence:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/:answerId/editing-presence/:editingSessionId',
    startQaAnswerEditingPresenceByModerationMagicLink:
        'moderators/answers/:answerId/editing-presence/:editingSessionId',
    getModerationRealtimeCredentials:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/realtime-credentials',
    getModerationRealtimeCredentialsByModerationMagicLink:
        'moderators/realtime-credentials',
    getQaAnswerEditingPresenceByEvent:
        'events/:eventId/engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/editing-presence',
    startQaAnswerEditingPresenceByEvent:
        'events/:eventId/engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/answers/:answerId/editing-presence/:editingSessionId',
    getModerationRealtimeCredentialsByEvent:
        'events/:eventId/engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/realtime-credentials',
    getQaRealtimeCredentials:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/realtime-credentials',
    getQaRealtimeCredentialsByModerationMagicLink:
        'moderators/realtime-credentials',
    // Live Now strip (participant homepage)
    getLiveNow: 'events/:eventId/live-now',
    getLiveNowRealtimeCredentials: 'events/:eventId/live-now/realtime-credentials',
    // Live Now manual activation (section 5.2). The magic-link route takes no instance id
    // because the token pins the instance.
    updateLiveActivation:
        'engagement-tools/:engagementToolId/instances/:engagementToolInstanceId/live-activation',
    updateLiveActivationByModerationMagicLink: 'moderators/live-activation',
    eventParticipantsForView: 'events/:eventId/participants/view',
    getDirectoryForView: 'events/:eventId/pages/view/:pageId/directory',
    getDirectoryForPreview: 'events/:eventId/pages/directory-preview',
    getDirectoryGroupByOptionsForView:
        'events/:eventId/pages/view/:pageId/directory/group-by-options',
    getDirectoryDetailForView:
        'events/:eventId/pages/view/:pageId/directory/:userId',
    getDirectoryFiltersForView:
        'events/:eventId/pages/view/:pageId/directory/filters',
    getSpeakerDirectoryDetailForView:
        'events/:eventId/sessions/v2/:sessionId/view/speaker/:userId',
    getUserDetailForView: 'events/:eventId/participants/:userId/profile',
    impersonateUserList: 'events/:eventId/participants/impersonate-user-list',
    // Chat participants
    getChatParticipants: 'events/:eventId/participants/chat-participants',
    getUnreadChatCount: 'events/:eventId/chats/unread',
    // Chat filters and options
    getChatFilters: 'events/:eventId/chats/filters',
    getChatUpdateOptions: 'events/:eventId/chats/update-options',
    // Chat CRUD
    getChats: 'events/:eventId/chats/',
    getChatById: 'events/:eventId/chats/:chatId',
    createChat: 'events/:eventId/chats/',
    // Chat messages
    getChatMessageFilters: 'events/:eventId/chats/:chatId/messages/filters',
    getChatMessageUpdateOptions:
        'events/:eventId/chats/:chatId/messages/update-options',
    getChatMessages: 'events/:eventId/chats/:chatId/messages/',
    getChatMessageById: 'events/:eventId/chats/:chatId/messages/:messageId',
    createChatMessage: 'events/:eventId/chats/:chatId/messages',
    getPeopleDetailForView:
        'events/:eventId/pages/:pageId/widgets/:widgetId/view/people/:userId',
    getP2PChatsReport: 'events/:eventId/chats/report',
    getBCXReport: 'events/:eventId/bcx-report',
};

export default apiRoutes;
